import SearchComponent from '../../../../molecules/search/index.jsx'
import { searchVariantsOptions } from '../../../../molecules/search/constants.js'
import ContextMenuComponent from '../../../context-menu/index.jsx'
import { Search } from '../../../../atoms/icons/core/index.js'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'
import TabsComponent from '../../../../atoms/tabs/index.jsx'
import { contextMenuSizeOptions } from '../../../context-menu/constants.js'
import BadgesComponent from '../../../../atoms/badges/index.jsx'
import {
  badgeColorOptions,
  badgeSizeOptions,
  badgesVariantOptions
} from '../../../../atoms/badges/constants.js'
import { GlobalSearchTabHeader } from './styled-components.js'
import { useRef, useState } from 'react'

import { GlobalSearchTabOptions } from '../../constants.js'
import PropTypes from 'prop-types'
import { iconSizeOptions } from '../../../../atoms/icons/icons-sizes.js'
import { SpinnerGrey } from '../../../../atoms/icons/special/index.js'
import { useIntl } from 'react-intl'

const GlobalSearch = ({
  setSearch = null,
  pinsListComponent = null,
  tasksListComponent = null,
  plansListComponent = null,
  counter = null,
  disabled = false,
  isOpen: isOpenProp = false,
  setIsOpen: setIsOpenProp = () => {}
}) => {
  const [isOpenNative, setIsOpenNative] = useState(false)

  const isOpen = isOpenProp || isOpenNative
  const setIsOpen = setIsOpenProp || setIsOpenNative

  const { formatMessage } = useIntl()
  const containerRef = useRef(null)

  const TabHeader = ({ tabName, counter }) => {
    return (
      <GlobalSearchTabHeader>
        <span>{tabName}</span>
        {counter >= 0 ? (
          <BadgesComponent
            variant={badgesVariantOptions.STRONG}
            color={badgeColorOptions.DOCU_TOOLS_DARK}
            size={badgeSizeOptions.SMALL}
          >
            {counter}
          </BadgesComponent>
        ) : (
          <SpinnerGrey size={iconSizeOptions['ICON-S']} />
        )}
      </GlobalSearchTabHeader>
    )
  }

  const handleOpen = () => {
    !isOpen && setIsOpen(true)
  }

  const tabContentStyle = {
    padding: 0,
    maxHeight: '400px',
    overflowY: 'auto'
  }

  return (
    <div style={{ width: '100%' }} ref={containerRef}>
      <SearchComponent.Root
        variant={searchVariantsOptions.GLOBAL}
        placeholder={formatMessage({ id: 'global_search_placeholder' })}
        onClick={handleOpen}
        customOnChange={setSearch}
        disabled={disabled}
      >
        <SearchComponent.Container>
          <SearchComponent.LeadingIcon
            icon={Search}
            size={iconSizeOptions['ICON-S']}
            stroke={colorsOptions.greys['grey-50']}
          />
          <SearchComponent.Input />
          <SearchComponent.ClearButton stroke={'white'} />
        </SearchComponent.Container>
      </SearchComponent.Root>
      <div>
        <ContextMenuComponent.Root
          size={contextMenuSizeOptions.DESKTOP}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          style={{ flex: 1, width: '100%' }}
          isSingle
          ref={containerRef}
        >
          <ContextMenuComponent.List
            width={null}
            maxHeight={'auto'}
            sideYOffSet={4}
            height={'auto'}
            style={{
              borderRadius: '20px'
            }}
          >
            <TabsComponent.Root defaultValue={GlobalSearchTabOptions.PINS}>
              <TabsComponent.List>
                <TabsComponent.Trigger value={GlobalSearchTabOptions.PINS}>
                  <TabHeader
                    tabName={formatMessage({ id: 'pins' })}
                    counter={counter.pins}
                  />
                </TabsComponent.Trigger>
                <TabsComponent.Trigger value={GlobalSearchTabOptions.TASKS}>
                  <TabHeader
                    tabName={formatMessage({ id: 'tasks' })}
                    counter={counter.tasks}
                  />
                </TabsComponent.Trigger>
                <TabsComponent.Trigger value={GlobalSearchTabOptions.PLANS}>
                  <TabHeader
                    tabName={formatMessage({ id: 'plans' })}
                    counter={counter.plans}
                  />
                </TabsComponent.Trigger>
              </TabsComponent.List>

              <TabsComponent.Content
                value={GlobalSearchTabOptions.PINS}
                style={{
                  ...tabContentStyle
                }}
              >
                {pinsListComponent}
              </TabsComponent.Content>
              <TabsComponent.Content
                value={GlobalSearchTabOptions.TASKS}
                style={{
                  ...tabContentStyle
                }}
              >
                {tasksListComponent}
              </TabsComponent.Content>
              <TabsComponent.Content
                value={GlobalSearchTabOptions.PLANS}
                style={{
                  ...tabContentStyle
                }}
              >
                {plansListComponent}
              </TabsComponent.Content>
            </TabsComponent.Root>
          </ContextMenuComponent.List>
        </ContextMenuComponent.Root>
      </div>
    </div>
  )
}

GlobalSearch.propTypes = {
  setSearch: PropTypes.func,
  counter: PropTypes.shape({
    pins: PropTypes.number,
    tasks: PropTypes.number,
    plans: PropTypes.number
  }),
  pinsListComponent: PropTypes.node,
  tasksListComponent: PropTypes.node,
  plansListComponent: PropTypes.node,
  disabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
}

export default GlobalSearch
